(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

window.$ = jQuery;

// window.FontAwesomeConfig = {};

// require('@fortawesome/fontawesome');
// require('@fortawesome/fontawesome-pro-solid');
// require('@fortawesome/fontawesome-pro-regular');
// require('@fortawesome/fontawesome-pro-light');
// require('@fortawesome/fontawesome-free-brands');

// require('./wp-functions.js');


function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

jQuery(document).ready(function($) {

  // $(document).foundation();



  // main mobile nav
  $('body').on('click', '.vbtk-toggle-mobile-nav', function(e){

    $('.site-mobile-nav').toggleClass('nav-open');
    $('body').toggleClass('scroll-locked');
    
  });


  if($('.vbtk-accordion').length > 0) {
    $( ".vbtk-accordion" ).accordion({
      heightStyle: "fill"
    });
  }


  // main mobile nav
  $('body').on('click', '.close-newsletter-bar', function(e){
    $('.newsletter-bar').fadeOut(120);
  });





  


  if($('.vbtk-popup.vbtk-popup-newsletter').length > 0) {
    
      if(getCookie('vbtk-firstVisit') === '') {

        $('.vbtk-popup.vbtk-popup-newsletter, .vbtk-popup-bg').delay(6000).fadeIn( 300, function() {
          // Animation complete
          setCookie('vbtk-firstVisit','false',1);
          $('body').addClass('scroll-locked');
        });
          
      }

      $('.vbtk-popup.vbtk-popup-newsletter .close-popup, .vbtk-popup-bg').on('click',function(){
          $('.vbtk-popup.vbtk-popup-newsletter, .vbtk-popup-bg').fadeOut(300);
          $('body').removeClass('scroll-locked');
      });
      
  }


	// // Adds Flex Video to YouTube and Vimeo Embeds
 //  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
 //    if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
 //      $(this).wrap("<div class='widescreen flex-video'/>");
 //    } else {
 //      $(this).wrap("<div class='flex-video'/>");
 //    }
 //  });

});

},{}]},{},[1]);
